import React, { useState, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../context/AuthContext';
import { countryCodes } from '../../data/countryCodes'; // Ülke listesini import et
const API_URL = process.env.REACT_APP_API_URL;
const BillingSettings = ({ formData, onFormChange }) => {
  const { t, i18n } = useTranslation();
  const { token } = useAuth();
  
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleBillingChange = (e) => {
      onFormChange({
          billing_details: {
              ...(formData.billing_details || {}),
              [e.target.name]: e.target.value
          }
      });
  };
  
  const handleCustomerTypeChange = (e) => {
    onFormChange({ customer_type: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage(''); setError(''); setIsSubmitting(true);
    try {
      const response = await fetch(`${API_URL}/api/auth/profile/billing`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
        body: JSON.stringify(formData.billing_details || {})
      });
      if (!response.ok) {
        const data = await response.json();
        throw new Error(t(data.messageKey) || t('error_billing_update'));
      }
      setMessage(t('success_billing_updated'));
    } catch (err) {
      setError(err.message);
    } finally {
        setIsSubmitting(false);
    }
  };

  const sortedCountryOptions = useMemo(() => {
    return [...countryCodes].sort((a, b) => 
      t(a.nameKey).localeCompare(t(b.nameKey), i18n.language)
    );
  }, [i18n.language, t]);

  if (!formData) return null;

  return (
    <div className="profile-form-container">
      <h2>{t('billing_info')}</h2>
      <form onSubmit={handleSubmit}>
        <div className="radio-group billing-type">
            <label className="auth-radio">
                <input type="radio" name="customer_type" value="bireysel" checked={formData.customer_type === 'bireysel'} onChange={handleCustomerTypeChange}/>
                <span>{t('individual_customer')}</span>
            </label>
            <label className="auth-radio">
                <input type="radio" name="customer_type" value="kurumsal" checked={formData.customer_type === 'kurumsal'} onChange={handleCustomerTypeChange}/>
                <span>{t('corporate_customer')}</span>
            </label>
        </div>

        {/* --- ORTAK ALANLAR --- */}
        <div className="form-group-auth">
          <label className="static-label">{t('country', 'Ülke')}</label>
          <select 
            name="country"
            value={formData.billing_details?.country || 'TR'} 
            onChange={handleBillingChange}
            required
          >
            {sortedCountryOptions.map(country => (
              <option key={country.code} value={country.code}>
                {t(country.nameKey)}
              </option>
            ))}
          </select>
        </div>
        <div className="form-group-auth floating-label">
            <input name="address" value={formData.billing_details?.address || ''} onChange={handleBillingChange} required placeholder=" " />
            <label>{t('address')}</label>
        </div>

        {formData.customer_type === 'kurumsal' ? (
            // --- KURUMSAL FATURA FORMU ---
            <>
                <div className="form-group-auth floating-label">
                    <input name="company_name" value={formData.billing_details?.company_name || ''} onChange={handleBillingChange} required placeholder=" " />
                    <label>{t('company_name')}</label>
                </div>
                <div className="form-row-auth">
                    <div className="form-group-auth floating-label half-width">
                        <input name="tax_office" value={formData.billing_details?.tax_office || ''} onChange={handleBillingChange} required placeholder=" " />
                        <label>{t('tax_office')}</label>
                    </div>
                    <div className="form-group-auth floating-label half-width">
                        <input name="tax_number" value={formData.billing_details?.tax_number || ''} onChange={handleBillingChange} required placeholder=" " />
                        <label>{t('tax_number')}</label>
                    </div>
                </div>
            </>
        ) : (
            // --- BİREYSEL FATURA FORMU ---
            <>
                <div className="form-group-auth floating-label">
                    <input name="tc_kimlik_no" value={formData.billing_details?.tc_kimlik_no || ''} onChange={handleBillingChange} required placeholder=" " />
                    <label>{t('tc_kimlik_no')}</label>
                </div>
            </>
        )}
        
        {message && <p className="auth-success">{message}</p>}
        {error && <p className="auth-error">{error}</p>}
        
        <button type="submit" className="cta-button" disabled={isSubmitting}>
            {isSubmitting ? t('saving') : t('save_changes')}
        </button>
      </form>
    </div>
  );
};

export default BillingSettings;